import React, { useContext, useState, useEffect, Fragment } from "react";
import Title from "../../common/Title";
import { Store } from "../../state/state";
import { toJS } from "mobx";
import ColorPickerUI from "../../common/ColorPickerUI";
import TextField from "../../common/TextField";
import MenuItem, { MenuTexture } from "../../common/Menu";
import { useObserver } from "mobx-react";

function SettingSelect({ select }) {
  const [selections, setSelections] = useState([]);
  const store = useContext(Store);
  let Result = "";

  if (select === "calendar-header") {
    console.log("here : ", toJS(store.theme.header));
    return <SettingHeader />;
  } else if (select.startsWith("note")) {
    const [, key] = select.split("-");
    return <SettingNote vkey={key} />;
  } else if (select.startsWith("weekly")) {
    console.log(toJS(store.theme.main.weekHeader));
    return <SettingWeekly />;
  } else return <div></div>;
}

function SettingHeader() {
  const store = useContext(Store);

  return (
    <div>
      <Title>عنوان التقويم</Title>
      <ColorPickerUI
        id={"header-background"}
        label={"الخلفية"}
        color={store.theme.header.backgroundColor}
        onChange={(v) => (store.theme.header.backgroundColor = v.hex)}
      />
      <MenuTexture
        value={store.theme.header.texture}
        onSelect={(v) => (store.theme.header.texture = v)}
        color={store.theme.header.backgroundColor}
      />
      <Title>خط العنوان</Title>
      <TextField type="text" label="المحتوى" />

      <ColorPickerUI
        id={"text-h1-text"}
        label={"اللون"}
        color={store.theme.header.h1.color}
        onChange={(color) => (store.theme.header.h1.color = color.hex)}
      />
      <TextField
        type="number"
        label="حجم الخط"
        value={store.theme.header.h1.fontSize}
        onChangeText={(t) => (store.theme.header.h1.fontSize = t)}
      />

      <MenuItem
        FontData
        label={"نوع الخط"}
        value={store.theme.header.h1.fontFamily}
        onSelect={(t) => (store.theme.header.h1.fontFamily = t)}
      />

      <MenuItem
        data={[
          { value: "normal", key: "عادي" },
          { value: "bold", key: "غامق" },
          { value: "italic", key: "مائل" },
        ]}
        label={"شكل الخط"}
        onSelect={(t) => (store.theme.header.h1.fontStyle = t)}
      />
      <Title>خط العام</Title>
      <TextField type="text" label="المحتوى" />

      <ColorPickerUI
        id={"text-h2-text"}
        label={"اللون"}
        color={store.theme.header.h2.color}
        onChange={(color) => (store.theme.header.h2.color = color.hex)}
      />
      <TextField
        type="number"
        label="حجم الخط"
        value={store.theme.header.h2.fontSize}
        onChangeText={(t) => (store.theme.header.h2.fontSize = t)}
      />

      <MenuItem
        FontData
        label={"نوع الخط"}
        value={store.theme.header.h2.fontFamily}
        onSelect={(t) => (store.theme.header.h2.fontFamily = t)}
      />

      <MenuItem
        data={[
          { value: "normal", key: "عادي" },
          { value: "bold", key: "غامق" },
          { value: "italic", key: "مائل" },
        ]}
        label={"شكل الخط"}
        onSelect={(t) => (store.theme.header.h2.fontStyle = t)}
      />
    </div>
  );
}
function SettingNote({ vkey: key, note }) {
  const store = useContext(Store);
  const notetYPE = key === "body" ? "جسم" : "عنوان";

  return useObserver(() => (
    <div>
      <Title>{notetYPE} الملاحظات </Title>

      <ColorPickerUI
        id={"note-header"}
        label={"الخلفية"}
        color={store.theme.note[key].backgroundColor}
        onChange={(v) => (store.theme.note[key].backgroundColor = v.hex)}
      />
      {key === "header" ? (
        <Fragment>
          <ColorPickerUI
            id="font-note"
            label={"اللون"}
            color={store.theme.note.header.text.color}
            onChange={(color) =>
              (store.theme.note.header.text.color = color.hex)
            }
          />
          <TextField
            type="number"
            label="حجم الخط"
            value={store.theme.note.header.text.fontSize}
            onChangeText={(txt) =>
              (store.theme.note.header.text.fontSize = txt)
            }
          />

          <MenuItem
            FontData
            label={"نوع الخط"}
            value={store.theme.note.header.text.fontFamily}
            onSelect={(e) => (store.theme.note.header.text.fontFamily = e)}
          />

          <MenuItem
            data={[
              { value: "normal", key: "عادي" },
              { value: "bold", key: "غامق" },
              { value: "italic", key: "مائل" },
            ]}
            value={store.theme.note.header.text.fontStyle}
            onSelect={(e) => (store.theme.note.header.text.fontStyle = e)}
            label={"شكل الخط"}
          />
        </Fragment>
      ) : (
        ""
      )}
      <MenuTexture
        value={store.theme.note[key].texture}
        onSelect={(v) => (store.theme.note[key].texture = v)}
        color={store.theme.note[key].backgroundColor}
      />
    </div>
  ));
}
function SettingWeekly() {
  const store = useContext(Store);

  return useObserver(() => (
    <div>
      <Title>الأسابيع</Title>
      <ColorPickerUI
        id={"weekly-header"}
        label={"الخلفية"}
        color={store.theme.main.weekHeader.backgroundColor}
        onChange={(v) => (store.theme.main.weekHeader.backgroundColor = v.hex)}
      />
      <ColorPickerUI
        id="font-week"
        label={"لون الخط"}
        color={store.theme.main.weekHeader.text.color}
        onChange={(color) =>
          (store.theme.main.weekHeader.text.color = color.hex)
        }
      />
      <TextField
        type="number"
        label="حجم الخط"
        value={store.theme.main.weekHeader.text.fontSize}
        onChangeText={(e) => (store.theme.main.weekHeader.text.fontSize = e)}
      />

      <MenuItem
        FontData
        label={"نوع الخط"}
        value={store.theme.main.weekHeader.text.fontFamily}
        onSelect={(data) =>
          (store.theme.main.weekHeader.text.fontFamily = data)
        }
      />

      <MenuItem
        data={[
          { value: "normal", key: "عادي" },
          { value: "bold", key: "غامق" },
          { value: "italic", key: "مائل" },
        ]}
        value={store.theme.main.weekHeader.text.fontStyle}
        onSelect={(e) => (store.theme.main.weekHeader.text.fontStyle = e)}
        label={"شكل الخط"}
      />
      <MenuTexture
        value={store.theme.main.weekHeader.texture}
        onSelect={(v) => (store.theme.main.weekHeader.texture = v)}
        color={store.theme.main.weekHeader.backgroundColor}
      />
    </div>
  ));
}

export default SettingSelect;
